import { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import axios from "axios";
import States from "../../utils/state.json";
import { ServerPath } from "../../Constant";
// import { uploadImage } from "../../Services/azure-storage-blob";
import Filter from "../../assets/images/svg/Filter.svg";
import UploadDrive from "../../assets//images/svg/DriveImg.svg";
import AadharUpload from "../../assets//images/svg/AadharImg.svg";
import filter from "../../assets//images/svg/Filter.svg";
import {uploadImage} from '../../Services/r2-storage-blob.js';
import { _axios } from "../../utils/axios.jsx";

// Convert ISO date (e.g., '2024-07-31T18:30:00.000Z') to 'YYYY-MM-DD'
const extractDateFromISO = (isoString) => {
  if (!isoString) return ''; // Handle undefined or null values
  const date = new Date(isoString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' }; // Format: Nov 19, 2024
  return date.toLocaleDateString('en-US', options);
};

const formatDateForConsole = (isoString) => {
  if (!isoString) return ''; // Handle undefined or null values
  const date = new Date(isoString);
  // Use padStart to ensure single digit days/months get a leading zero
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() returns 0-11
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const formatDateForInput = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const AddUser = (props) => {
  console.log("user Details", props?.data);

  // For Aadhar card front
  const [imageAadharPreview, setImageAadharPreview] = useState(
    props?.data?.doc_front ?? null
  );
  const [selectedAadharFile, setAadharSelectedFile] = useState(null);
  const [uploadAadharStatus, setUploadAadharStatus] = useState("");
  // const [aadharFrontUrl, setAadharFrontUrl] = useState("");
  const [aadharFrontUrl, setAadharFrontUrl] = useState(props?.data?.doc_front ?? "");
  const [aadharBackUrl, setAadharBackUrl] = useState(props?.data?.doc_back ?? "");
  // const [documentType, setDocumentType] = useState(props?.data?.doc_type);
  const [documentType, setDocumentType] = useState(() => {
    // If props data exists, determine document type from existing documents
    if (props?.data) {
      if (props.data.doc_front && props.data.doc_back) {
        return "Aadhar Card";
      } else if (props.data.driving_license_url) {
        return "Driving License";
      } else if (props.data.voter_id_url) {
        return "Voter ID";
      }
    }
    return ""; // default value if no document exists
  });

  const [isCertifyingAuthority, setIsCertifyingAuthority] = useState(
    props?.data?.is_a_certifying_authority ?? false
  );
  const [verifyingOrganisation, setVerifyingOrganisation] = useState(
    props?.data?.verifying_organisation ?? ""
  );

  const handleImageChangeAadhar = async (e) => {
    if (drivingLicenseUrl) {
      setError("Please remove driving license first to upload Aadhar card");
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setAadharSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => { };
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_Aadharimage_${Date.now()}`;
        const container = "web-Aadharapp";
        const subcontainer = "Aadhar-images";

        // setUploadAadharStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url ", url);
        setImageAadharPreview(url);
        setAadharFrontUrl(url);
        setUploadAadharStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadAadharStatus("Upload failed. Please try again.");
      }
    }
  };
  // For Aadhar Back
  const [imageAadharBackPreview, setImageAadharBackPreview] = useState(
    props?.data?.doc_back ?? null
  );
  const [selectedAadharBackFile, setAadharBackSelectedFile] = useState(null);
  const [uploadAadharBackStatus, setUploadAadharBackStatus] = useState("");
  // const [aadharBackUrl, setAadharBackUrl] = useState("");

  const handleImageChangeAadharBack = async (e) => {
    if (drivingLicenseUrl) {
      setError("Please remove driving license first to upload Aadhar card");
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setAadharBackSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => { };
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_Aadharimage_${Date.now()}`;
        const container = "web-Aadharapp";
        const subcontainer = "Aadhar-images";

        setUploadAadharBackStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url", url);
        setImageAadharBackPreview(url);
        setAadharBackUrl(url);
        setUploadAadharBackStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);

        setUploadAadharBackStatus("Upload failed. Please try again.");
      }
    }
  };
  // For Driving License
  const [imagePreview, setImagePreview] = useState(
    props?.data?.driving_license_url ?? null
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  // const [drivingLicenseUrl, setDrivingLicenseUrl] = useState("");
  const [drivingLicenseUrl, setDrivingLicenseUrl] = useState(props?.data?.driving_license_url ?? "");

  const handleImageChange = async (e) => {
    if (aadharFrontUrl || aadharBackUrl) {
      setError(
        "Please remove Aadhar card images first to upload driving license"
      );
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => { };
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_image_${Date.now()}`;
        const container = "web-app";
        const subcontainer = "images";

        setUploadStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url driving ", url);
        setImagePreview(url);
        setDrivingLicenseUrl(url);
        setUploadStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadStatus("Upload failed. Please try again.");
      }
    }
  };

  // const [selectedFile, setSelectedFile] = useState(null);
  const [voterIdSelectedFile, setVoterIdSelectedFile] = useState(null);
  const [voterIdPreview, setVoterIdPreview] = useState(
    props?.data?.voter_id_url ?? null
  );
  // const [voterIdUrl, setVoterIdUrl] = useState("");
  const [voterIdUrl, setVoterIdUrl] = useState(props?.data?.voter_id_url ?? "");

  const handleVoterIdChange = async (e) => {
    if (aadharFrontUrl || aadharBackUrl || drivingLicenseUrl) {
      setError("Please remove other document images first to upload voter ID");
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      setVoterIdSelectedFile(file);

      try {
        const filename = `web_image_${Date.now()}`;
        const container = "web-app";
        const subcontainer = "images";

        setUploadStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        setVoterIdPreview(url);
        setVoterIdUrl(url);
        setUploadStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadStatus("Upload failed. Please try again.");
      }
    }
  };

  const handleDocumentTypeChange = (e) => {
    const newType = e.target.value;
    setDocumentType(newType);

    // Clear existing uploads when switching document type
    if (newType === "Aadhar Card") {
      setImagePreview(null);
      setVoterIdPreview(null);
      setDrivingLicenseUrl("");
      setVoterIdUrl("");
      setSelectedFile(null);
      setVoterIdSelectedFile(null);
    } else if (newType === "Driving License") {
      setImageAadharPreview(null);
      setImageAadharBackPreview(null);
      setVoterIdPreview(null);
      setAadharFrontUrl("");
      setAadharBackUrl("");
      setVoterIdUrl("");
      setAadharSelectedFile(null);
      setAadharBackSelectedFile(null);
      setVoterIdSelectedFile(null);
    } else if (newType === "Voter ID") {
      setImageAadharPreview(null);
      setImageAadharBackPreview(null);
      setImagePreview(null);
      setAadharFrontUrl("");
      setAadharBackUrl("");
      setDrivingLicenseUrl("");
      setAadharSelectedFile(null);
      setAadharBackSelectedFile(null);
      setSelectedFile(null);
    }

    setError("");
  };

  useEffect(() => {
    console.log('Current Document Type:', documentType);
    console.log('Aadhar Front URL:', aadharFrontUrl);
    console.log('Aadhar Back URL:', aadharBackUrl);
    console.log('Driving License URL:', drivingLicenseUrl);
    console.log('Voter ID URL:', voterIdUrl);
  }, [documentType, aadharFrontUrl, aadharBackUrl, drivingLicenseUrl, voterIdUrl]);

  // const handleDocumentTypeChange = (e) => {
  //   const newType = e.target.value;
  //   setDocumentType(newType);

  //   // Clear existing uploads when switching document type
  //   if (newType === "Aadhar Card") {
  //     setImagePreview(null);
  //     setVoterIdPreview(null);
  //     setDrivingLicenseUrl("");
  //     setVoterIdUrl("");
  //     setSelectedFile(null);
  //     setVoterIdSelectedFile(null);
  //   } else if (newType === "Driving License") {
  //     setImageAadharPreview(null);
  //     setImageAadharBackPreview(null);
  //     setVoterIdPreview(null);
  //     setAadharFrontUrl("");
  //     setAadharBackUrl("");
  //     setVoterIdUrl("");
  //     setAadharSelectedFile(null);
  //     setAadharBackSelectedFile(null);
  //     setVoterIdSelectedFile(null);
  //   } else if (newType === "Voter ID") {
  //     setImageAadharPreview(null);
  //     setImageAadharBackPreview(null);
  //     setImagePreview(null);
  //     setAadharFrontUrl("");
  //     setAadharBackUrl("");
  //     setDrivingLicenseUrl("");
  //     setAadharSelectedFile(null);
  //     setAadharBackSelectedFile(null);
  //     setSelectedFile(null);
  //   }

  //   setError("");
  // };

  const [show, setShow] = useState(false);
  const [userName, setUserName] = useState(props?.data?.user_name ?? "");
  const [userMiddleName, setUserMiddleName] = useState(
    props?.data?.middle_name ?? ""
  );
  const [userLastName, setUserLastName] = useState(
    props?.data?.last_name ?? ""
  );
  // const [userPhoneNumber, setUserPhoneNumber] = useState(
  //   props?.data?.mobile ?? ""
  // );
  const [country, setCountry] = useState(props?.data?.country ?? "India");
  const [selectedStateDistrict, setSelectedStateDistrict] = useState([]);
  const [state, setState] = useState(() => {
    const selectedState = States.find(
      (item) => item.state === props?.data?.state
    );
    setSelectedStateDistrict(selectedState?.districts ?? []);
    return props?.data?.state ?? 0;
  });
  const [district, setDistrict] = useState(props?.data?.district ?? 0);
  const [city, setCity] = useState(props?.data?.city ?? "");
  const [pinCode, setPinCode] = useState(props?.data?.pin_code ?? "");
  const [address, setAddress] = useState(props?.data?.address ?? "");
  // const [email, setEmail] = useState('');

  const [mobile, setMobile] = useState(props?.data?.mobile ?? "");
  // const [password, setPassword] = useState('');
  const [dob, setDob] = useState(
    extractDateFromISO(props?.data?.dob ?? props?.data?.dateofbirth ?? "")
  );
  // const [dateOfBirth, setdateOfBirth] = useState(
  //   formatDateForConsole(props?.data?.dob ?? props?.data?.dateofbirth ?? "")
  // );
  const [dateOfBirth, setDateOfBirth] = useState(
    formatDateForInput(props?.data?.dob ?? props?.data?.dateofbirth ?? "")
  );
  const [bloodGroup, setBloodGroup] = useState(props?.data?.bloodgroup ?? null);
  const [emergencyContactName, setEmergencyContactName] = useState(
    props?.data?.emergency_contact_name ?? ""
  );
  const [emergencyContactRelation, setEmergencyContactRelation] = useState(
    props?.data?.relationship ?? null
  );
  const [emergencyContactNumber, setEmergencyContactNumber] = useState(
    props?.data?.emergency_contact_mobile ?? ""
  );
  const [emergencyContactAlternateNumber, setEmergencyContactAlternateNumber] =
    useState(props?.data?.emergency_contact_mobile_alt ?? "");

  const [secondEmergencyContactName, setSecondEmergencyContactName] = useState(
    props?.data?.emergency_contact_name_two ?? ""
  );
  const [secondEmergencyContactRelation, setSecondEmergencyContactRelation] =
    useState(props?.data?.relationship_two ?? null);
  const [secondEmergencyContactNumber, setSecondEmergencyContactNumber] =
    useState(props?.data?.emergency_contact_mobile_two ?? "");
  const [
    secondEmergencyContactAlternateNumber,
    setSecondEmergencyContactAlternateNumber,
  ] = useState(props?.data?.emergency_contact_mobile_two_alt ?? "");

  const [thirdEmergencyContactName, setThirdEmergencyContactName] = useState(
    props?.data?.emergency_contact_name_three ?? ""
  );
  const [thirdEmergencyContactRelation, setThirdEmergencyContactRelation] =
    useState(props?.data?.relationship_three ?? null);
  const [thirdEmergencyContactNumber, setThirdEmergencyContactNumber] =
    useState(props?.data?.emergency_contact_mobile_three ?? "");
  const [
    thirdEmergencyContactAlternateNumber,
    setThirdEmergencyContactAlternateNumber,
  ] = useState(props?.data?.emergency_contact_mobile_three_alt ?? "");

  const [userSignedUpAsHost, setUserSignedUpAsHost] = useState(
    props?.data?.user_signed_up_as_host ?? ""
  );
  const [userSignedUpAsVolunteer, setUserSignedUpAsVolunteer] = useState(
    props?.data?.user_signed_up_as_volunteer ?? ""
  );
  const [userImage, setUserImage] = useState("");
  const [userLogData, setUserLogData] = useState();
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [error, setError] = useState("");
  const [stampImage, setStampImage] = useState("");
  const [stampImageUrl, setStampImageUrl] = useState("");


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const body = {
          user_id: props?.data?.user_id,
        };
        const response = await _axios.post(
          `${ServerPath}/map/user-coordinates`,
          body
        );
        console.log("user Coordinates", response.data);
        const actualData = response?.data?.data;
        if (response?.data?.data.length > 0) setUserLogData(actualData[0]);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchData();
  }, []);

  const exceedsBy7Days = (dateString) => {
    // Parse the given date
    const givenDate = new Date(dateString);
    // Get the current date
    const today = new Date();

    // Normalize both dates to midnight in local time
    const sevenDaysFromNow = new Date(givenDate); // Clone today's date
    sevenDaysFromNow.setDate(givenDate.getDate() + 7); // Add 7 days

    // Compare the dates
    return today > sevenDaysFromNow; // Returns true if the given date exceeds by more than 7 days
  };

  const handleFileChange = async(e) => {
     const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setStampImage(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => { };
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_Stampimage_${Date.now()}`;
        const container = "web-stamp";
        const subcontainer = "stamp-images";

        // setUploadAadharStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url ", url);
        console.log("Stamp Image URL:", url);
        setStampImageUrl(url);
      }
       catch (error) {
        console.error("Error uploading image:", error);
        setUploadStatus("Upload failed. Please try again.");
      }
    }
  };

  const calculateAge = (dobString) => {
    // Return empty string if no date is selected
    if (!dobString) return "";

    const dob = new Date(dobString); // Parse the date of birth
    if (isNaN(dob.getTime())) return "";
    const today = new Date(); // Get the current date

    // Return empty string if future date is selected
    if (dob > today) return "";

    let age = today.getFullYear() - dob.getFullYear(); // Initial age calculation based on year difference
    const monthDifference = today.getMonth() - dob.getMonth();
    const dayDifference = today.getDate() - dob.getDate();

    // Adjust the age if the current month/day is before the birth month/day
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age.toString();
  };
  // Get today's date in YYYY-MM-DD format for max attribute
  const today = new Date().toISOString().split("T")[0];

  // functionality for clicking the "Add More" button generates a new row

  const [contacts, setContacts] = useState(
    props?.data?.emergency_contact_name_two?.length > 1 &&
      props?.data?.emergency_contact_name_three?.length > 1
      ? [
        {
          name: props?.data?.emergency_contact_name ?? "",
          relation: props?.data?.relationship ?? null,
          number: props?.data?.emergency_contact_mobile ?? "",
          alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
        },
        {
          name: props?.data?.emergency_contact_name_two ?? "",
          relation: props?.data?.relationship_two ?? null,
          number: props?.data?.emergency_contact_mobile_two ?? "",
          alternateNumber:
            props?.data?.emergency_contact_mobile_two_alt ?? "",
        },
        {
          name: props?.data?.emergency_contact_name_three ?? "",
          relation: props?.data?.relationship_three ?? null,
          number: props?.data?.emergency_contact_mobile_three ?? "",
          alternateNumber:
            props?.data?.emergency_contact_mobile_three_alt ?? "",
        },
      ]
      : props?.data?.emergency_contact_name_two?.length > 1
        ? [
          {
            name: props?.data?.emergency_contact_name ?? "",
            relation: props?.data?.relationship ?? null,
            number: props?.data?.emergency_contact_mobile ?? "",
            alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
          },
          {
            name: props?.data?.emergency_contact_name_two ?? "",
            relation: props?.data?.relationship_two ?? null,
            number: props?.data?.emergency_contact_mobile_two ?? "",
            alternateNumber:
              props?.data?.emergency_contact_mobile_two_alt ?? "",
          },
        ]
        : [
          {
            name: props?.data?.emergency_contact_name ?? "",
            relation: props?.data?.relationship ?? null,
            number: props?.data?.emergency_contact_mobile ?? "",
            alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
          },
        ]
  );

  const handleContactChange = (index, field, value) => {
    setContacts((prevContacts) => {
      const newContacts = [...prevContacts];
      newContacts[index] = {
        ...newContacts[index],
        [field]: value,
      };
      return newContacts;
    });
  };

  const handleAddMore = () => {
    if (contacts.length < 3) {
      setContacts([
        ...contacts,
        {
          name: "",
          relation: null,
          number: "",
          alternateNumber: "",
        },
      ]);
    }
  };

  const handleRemoveContact = (index) => {
    setContacts(contacts.filter((_, i) => i !== index));
  };

  const hasExistingAadhar = props?.data?.doc_front && props?.data?.doc_back;
  const hasExistingDrivingLicense = props?.data?.driving_license_url;
  const hasExistingVoterId = props?.data?.voter_id_url;

  const handleSubmit = async (event) => {
    event.preventDefault();

    setUploading(true);

    if (
      userName.length < 1 ||
      userLastName.length < 1 ||
      mobile.length < 10 ||
      state.length < 2 ||
      district.length < 2 ||
      city.length < 1 ||
      pinCode.length < 6 ||
      address.length < 0 ||
      dateOfBirth.length < 0 ||
      bloodGroup.length < 0
    ) {
      setUploading(false);
      setError("Please fill in all Personal Details fields before submitting.");
      return; // Stop the submission if there are empty fields
    }
    // Validate emergency contacts
    if (contacts.length > 0) {
      for (let i = 0; i < contacts.length; i++) {
        const contact = contacts[i];
        if (
          contact.name?.length < 1 ||
          contact.relation?.length < 2 ||
          contact.number?.length < 10 ||
          contact.alternateNumber.length < 10
        ) {
          setUploading(false);
          setError(
            `Please fill in all Emergency Contact ${i + 1
            } fields before submitting.`
          );
          return; // Stop the submission if there are empty fields
        }
      }
    }
    if (isCertifyingAuthority && verifyingOrganisation.length < 1) {
      setUploading(false);
      setError("Please enter verifying organisation details when certifying authority is checked.");
      return;
    }

    // --------- Document validation - either Aadhar (both sides) OR driving license required-------------------------------------------------
    // const hasAadhar = aadharFrontUrl && aadharBackUrl;
    // const hasDrivingLicense = drivingLicenseUrl;
    // const hasVoterId = voterIdUrl;
    const hasAadhar = aadharFrontUrl || hasExistingAadhar;
    const hasDrivingLicense = drivingLicenseUrl || hasExistingDrivingLicense;
    const hasVoterId = voterIdUrl || hasExistingVoterId;

    // if (!aadharFrontUrl && !drivingLicenseUrl && !voterIdUrl) {
    //   setUploading(false);
    //   setError(
    //     "Please upload either Aadhar Card (both front and back) OR Driving License OR Voter ID."
    //   );
    //   return;
    // }
    if (!aadharFrontUrl && !drivingLicenseUrl && !voterIdUrl &&
      !hasExistingAadhar && !hasExistingDrivingLicense && !hasExistingVoterId) {
      setUploading(false);
      setError(
        "Please upload either Aadhar Card (both front and back) OR Driving License OR Voter ID."
      );
      return;
    }

    // if (
    //   (hasAadhar && hasDrivingLicense) ||
    //   (hasAadhar && hasVoterId) ||
    //   (hasDrivingLicense && hasVoterId)
    // ) {
    //   setUploading(false);
    //   setError(
    //     "Please upload only one type of document: either Aadhar Card OR Driving License OR Voter ID."
    //   );
    //   return;
    // }
    if ((hasAadhar && hasDrivingLicense) ||
      (hasAadhar && hasVoterId) ||
      (hasDrivingLicense && hasVoterId)) {
      setUploading(false);
      setError(
        "Please upload only one type of document: either Aadhar Card OR Driving License OR Voter ID."
      );
      return;
    }
    console.log(
      "Selected document type:",
      documentType || props?.data?.document_type || ""
    );

    setError("");
    try {
      const createUser = {
        user_name: userName,
        middle_name: userMiddleName,
        last_name: userLastName,
        is_a_certifying_authority: isCertifyingAuthority,
        verifying_organisation: verifyingOrganisation,
        country: country,
        state: state,
        district: district,
        city: city,
        pin_code: pinCode,
        address: address,
        dateofbirth: dateOfBirth,
        bloodgroup: bloodGroup,
        mobile: mobile,
        doc_front: hasAadhar ? aadharFrontUrl : "",
        doc_back: hasAadhar ? aadharBackUrl : "",
        driving_license_url: hasDrivingLicense ? drivingLicenseUrl : "",
        voter_id_url: hasVoterId ? voterIdUrl : "",
        // First emergency contact
        emergency_contact_name: contacts[0]?.name || "",
        relationship: contacts[0]?.relation || "",
        emergency_contact_mobile: contacts[0]?.number || "",
        emergency_contact_mobile_alt: contacts[0]?.alternateNumber || "",
        // Second emergency contact
        emergency_contact_name_two: contacts[1]?.name || "",
        relationship_two: contacts[1]?.relation || "",
        emergency_contact_mobile_two: contacts[1]?.number || "",
        emergency_contact_mobile_two_alt: contacts[1]?.alternateNumber || "",
        // Third emergency contact
        emergency_contact_name_three: contacts[2]?.name || "",
        relationship_three: contacts[2]?.relation || "",
        emergency_contact_mobile_three: contacts[2]?.number || "",
        emergency_contact_mobile_three_alt: contacts[2]?.alternateNumber || "",

        user_signed_up_as_host: userSignedUpAsHost,
        user_signed_up_as_volunteer: userSignedUpAsVolunteer,
        user_signed_up_as_host: userSignedUpAsHost ? 1 : 0,
        user_signed_up_as_volunteer: userSignedUpAsVolunteer ? 1 : 0,
        stamp_image: stampImageUrl || props?.data?.stamp_image || "",
      };

      const updateUser = { ...createUser, user_id: props?.data?.user_id };

      const response = props.isAddUser
        ? await _axios.post(`${ServerPath}/users/admin-create`, createUser)
        : await _axios.patch(`${ServerPath}/users/update`, updateUser);

      console.log(response.data);

      handleClose();
      window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  // console.log('Creation date:', props?.data?.create_on);
  // console.log('Formatted creation date:', extractDateFromISO(props?.data?.create_on));
  // console.log('Last logged on:', props?.userLogData?.last_logged_on);
  // console.log('Formatted last logged:', extractDateFromISO(props?.userLogData?.last_logged_on));

  // // console.log('DOB from props.data.dob:', props?.data?.dob);
  // console.log('DOB from props.data.dateofbirth:', props?.data?.dateofbirth);
  // console.log('DOB from props.data.dateofbirth (formatted):',
  //   formatDateForConsole(props?.data?.dateofbirth)
  // );
  // console.log('Extracted DOB:', extractDateFromISO(props?.data?.dob ?? props?.data?.dateofbirth ?? ""));
  // console.log('Current DOB state:', dob);


  console.log('Props Data:', props.data);
  // console.log('Last Logged On:', props.data?.last_logged_on);  
  console.log('Document Type:', props.data?.doc_type);


  return (
    <>
      {props?.isAddUser ? (
        <div className="d-flex justify-content-end align-items-center">
          <button onClick={handleShow} className="btn btn-primary ">
            Create User
          </button>
        </div>
      ) : props?.isEditButton ? (
        <OverlayTrigger
          placement="top" // You can change this to "bottom", "left", or "right"
          overlay={
            <Tooltip
              id="tooltip-edit"

            >
              Edit
            </Tooltip>
          }
        >
          <Button
            onClick={handleShow}
            className="btn-square btn btn-primary mx-2"
          >
            <i className="icon-pencil-alt"></i>
          </Button>
        </OverlayTrigger>
      ) : (
        <a
          onClick={handleShow}
          className="text-decoration-none float-end"
          style={{ cursor: "pointer" }}
        >
          {props?.data?.user_id}
        </a>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create User</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          {error && <div className="alert alert-danger">{error}</div>}
          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              <h5 className="txt-primary">Personal Details</h5>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    First Name <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Last Name <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    value={userLastName}
                    onChange={(e) => setUserLastName(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter phone number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    maxLength={10}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Country <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Country"
                    value={country}
                    disabled
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    State <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={state}
                    onChange={(e) => {
                      if (state !== e.target.value) {
                        setDistrict(0);
                      }
                      const selectedState = States.find(
                        (item) => item.state === e.target.value
                      );
                      setSelectedStateDistrict(selectedState?.districts ?? []);
                      setState(e.target.value);
                    }}
                  >
                    <option disabled selected value={0}>
                      {"Select state"}
                    </option>
                    {States.map((item) => {
                      return <option value={item.state}>{item.state}</option>;
                    })}
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    District <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                  >
                    <option disabled selected value={0}>
                      {"Select district"}
                    </option>
                    {selectedStateDistrict?.length > 0 &&
                      selectedStateDistrict.map((item) => {
                        return (
                          <option value={item.district}>{item.district}</option>
                        );
                      })}
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Town/City <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter town/city name"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Pincode <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter pincode"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Label>
                  Plot No, Street Address
                  <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <textarea
                  rows="3"
                  class="form-control form-control"
                  placeholder="Enter plot no,street address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Col>

              <Col md={3} className="mt-3">
                <Form.Group controlId="formGridCertifyingAuthority" className="mt-5">
                  <Form.Check
                    type="checkbox"
                    label="Is a Certifying Authority"
                    checked={isCertifyingAuthority}
                    onChange={(e) => {
                      setIsCertifyingAuthority(e.target.checked);
                      if (!e.target.checked) {
                        setVerifyingOrganisation("");
                      }
                    }}
                  />
                </Form.Group>
              </Col>

              {isCertifyingAuthority && (
                <Col md={3} className="mt-3">
                  <Form.Group controlId="formGridVerifyingOrganisation" className="mt-2">
                    <Form.Label>
                      Verifying Organisation <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <textarea
                      rows="3"
                      class="form-control form-control"
                      placeholder="Enter Organisation Name"
                      value={verifyingOrganisation}
                      onChange={(e) => setVerifyingOrganisation(e.target.value)}
                    />
                  </Form.Group>
                   <Form.Group controlId="formGridUserImage">
                                    <Form.Label>Stamp</Form.Label>
                                    <Form.Control
                                      type="file"
                                      onChange={handleFileChange}
                                      accept="image/*"
                                    />
                                  </Form.Group>
                </Col>
              )}

              <hr className="mt-4"></hr>

              <h5 className="txt-primary">Emergency Details</h5>

              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Blood Group <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={null}
                    value={bloodGroup}
                    onChange={(e) => setBloodGroup(e.target.value)}
                  >
                    <option selected disabled value={null}>
                      {"Select blood group"}
                    </option>
                    <option value="A+">{"A RhD positive (A+)"}</option>
                    <option value="A-">{"A RhD negative (A-)"}</option>
                    <option value="B+">{"B RhD positive (B+)"}</option>
                    <option value="B-">{"B RhD negative (B-)"}</option>
                    <option value="O+">{"O RhD positive (O+)"}</option>
                    <option value="O-">{"O RhD negative (O-)"}</option>
                    <option value="AB+">{"AB RhD positive (AB+)"}</option>
                    <option value="AB-">{"AB RhD negative (AB-)"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Date of Birth <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter DOB"
                    value={dateOfBirth}
                    max={today} // Prevents selection of future dates
                    // onChange={(e) => {
                    //   console.log("dob", e.target.value);
                    //   setDob(e.target.value);
                    onChange={(e) => {
                      console.log("dob (DD-MM-YYYY):", formatDateForInput(e.target.value));
                      setDateOfBirth(e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group
                  controlId="formGridUserName"
                  className="input-group-solid"
                >
                  <Form.Label>
                    Age <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Age"
                    // value={calculateAge(dob) ?? 0}
                    value={calculateAge(dateOfBirth)}
                    disabled
                  />
                </Form.Group>
              </Col>

              <Form.Label>
                Adhar Card Front & Back or Driving License or Voter ID
                attachment <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Col md={3} className="mt-0">
                <Form.Group controlId="formGridDocType">
                  <Form.Label>Document Type</Form.Label>
                  <select
                    name="documentType"
                    className="form-control form-select form-select"
                    value={documentType}
                    onChange={handleDocumentTypeChange}
                  >
                    <option value="">Select</option>
                    <option value="Aadhar Card">Aadhar Card</option>
                    <option value="Driving License">Driving License</option>
                    <option value="Voter ID">Voter ID</option>
                  </select>
                </Form.Group>
              </Col>

              {documentType === "Aadhar Card" && (
                <>
                  <Col md={3} className="mt-0">
                    <Form.Group controlId="formGridAadhar">
                      <input
                        type="file"
                        id="file-upload-aadhar"
                        accept="image/*,.pdf"
                        onChange={handleImageChangeAadhar}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="file-upload-aadhar"
                        className="w-100 cursor-pointer"
                      >
                        {imageAadharPreview ? (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={imageAadharPreview}
                            alt="Upload file aadhar front side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={AadharUpload}
                            alt="Upload file aadhar front side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        )}
                      </label>
                    </Form.Group>
                  </Col>
                  <Col md={3} className="mt-0">
                    <Form.Group controlId="formGridAadharBack">
                      <input
                        type="file"
                        id="file-upload-aadhar-back"
                        accept="image/*,.pdf"
                        onChange={handleImageChangeAadharBack}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="file-upload-aadhar-back"
                        className="w-100 cursor-pointer"
                      >
                        {imageAadharBackPreview ? (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={imageAadharBackPreview}
                            alt="Upload file aadhar back side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={AadharUpload}
                            alt="Upload file aadhar back side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        )}
                      </label>
                    </Form.Group>
                  </Col>
                </>
              )}

              {documentType === "Driving License" && (
                <Col md={3} className="mt-0">
                  <Form.Group controlId="formGridDrivingLicense">
                    <input
                      type="file"
                      id="file-upload"
                      accept="image/*,.pdf"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="file-upload" className="w-100 cursor-pointer">
                      {imagePreview ? (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={imagePreview}
                          alt="driving license preview"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      ) : (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={UploadDrive}
                          alt="upload driving license"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      )}
                    </label>
                  </Form.Group>
                </Col>
              )}

              {documentType === "Voter ID" && (
                <Col md={3} className="mt-0">
                  <Form.Group controlId="formGridVoterId">
                    <input
                      type="file"
                      id="file-upload-voter"
                      accept="image/*,.pdf"
                      onChange={handleVoterIdChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="file-upload-voter" className="w-100 cursor-pointer">
                      {voterIdPreview ? (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={voterIdPreview}
                          alt="voter id preview"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      ) : (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={UploadDrive} // You might want to use a different upload icon
                          alt="upload voter id"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      )}
                    </label>
                  </Form.Group>
                </Col>
              )}

              {/*---------------------- Emergency Contact Info---------------------------------*/}
              {/* <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Emergency Contact Info</h6>
                <button type="button" className="btn btn-primary">
                  Add More
                </button>
              </div>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    value={emergencyContactName}
                    onChange={(e) => setEmergencyContactName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Relationship</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={null}
                    value={emergencyContactRelation}
                    onChange={(e) =>
                      setEmergencyContactRelation(e.target.value)
                    }
                  >
                    <option disabled selected value={null}>
                      {"Select relationship"}
                    </option>
                    <option value={"Father"}>{"Father"}</option>
                    <option value={"Mother"}>{"Mother"}</option>
                    <option value={"Brother"}>{"Brother"}</option>
                    <option value={"Sister"}>{"Sister"}</option>
                    <option value={"Cousin"}>{"Cousin"}</option>
                    <option value={"Uncle"}>{"Uncle"}</option>
                    <option value={"Friend"}>{"Friend"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Primary Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter primary mobile number"
                    value={emergencyContactNumber}
                    onChange={(e) => setEmergencyContactNumber(e.target.value)}
                    maxLength={10}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>{"Alternate Mobile Number(Optional)"}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter alternate mobile number"
                    value={emergencyContactAlternateNumber}
                    onChange={(e) =>
                      setEmergencyContactAlternateNumber(e.target.value)
                    }
                    maxLength={10}
                  />
                </Form.Group>
              </Col> */}

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Emergency Contact Info</h6>
                {contacts.length < 3 && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAddMore}
                  >
                    Add More
                  </button>
                )}
              </div>

              {contacts.map((contact, index) => (
                <div key={index} className="row mb-4 position-relative">
                  <Col md={3}>
                    <Form.Group controlId={`formGridUserName-${index}`}>
                      <Form.Label>
                        Full Name <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="First Name"
                        value={contact.name}
                        onChange={(e) =>
                          handleContactChange(index, "name", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridRelationship-${index}`}>
                      <Form.Label>
                        Relationship <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={contact.relation}
                        onChange={(e) =>
                          handleContactChange(index, "relation", e.target.value)
                        }
                      >
                        <option value="">Select Option</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Brother">Brother</option>
                        <option value="Sister">Sister</option>
                        <option value="Cousin">Cousin</option>
                        <option value="Uncle">Uncle</option>
                        <option value="Friend">Friend</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridPrimaryNumber-${index}`}>
                      <Form.Label>
                        Primary Mobile Number
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={contact.number}
                        onChange={(e) =>
                          handleContactChange(index, "number", e.target.value)
                        }
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridAlternateNumber-${index}`}>
                      <Form.Label>Alternate Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={contact.alternateNumber}
                        onChange={(e) =>
                          handleContactChange(
                            index,
                            "alternateNumber",
                            e.target.value
                          )
                        }
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>

                  {/* {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        style={{ top: 0, right: 15 }}
                        onClick={() => handleRemoveContact(index)}
                      >
                        Remove
                      </button>
                    )} */}
                </div>
              ))}

              {/* {(props?.isAddUser ||
                props?.data?.emergency_contact_name_two) && (
                <>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="First Name"
                        value={secondEmergencyContactName}
                        onChange={(e) =>
                          setSecondEmergencyContactName(e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Relationship</Form.Label>
                      <select
                        name="select"
                        class="form-control form-select form-select"
                        defaultValue={null}
                        value={secondEmergencyContactRelation}
                        onChange={(e) =>
                          setSecondEmergencyContactRelation(e.target.value)
                        }
                      >
                        <option disabled selected value={null}>
                          {"Select Option"}
                        </option>
                        <option value={"Father"}>{"Father"}</option>
                        <option value={"Mother"}>{"Mother"}</option>
                        <option value={"Brother"}>{"Brother"}</option>
                        <option value={"Sister"}>{"Sister"}</option>
                        <option value={"Cousin"}>{"Cousin"}</option>
                        <option value={"Uncle"}>{"Uncle"}</option>
                        <option value={"Friend"}>{"Friend"}</option>
                      </select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Primary Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={secondEmergencyContactNumber}
                        onChange={(e) =>
                          setSecondEmergencyContactNumber(e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>
                        {"Alternate Mobile Number(Optional)"}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={secondEmergencyContactAlternateNumber}
                        onChange={(e) =>
                          setSecondEmergencyContactAlternateNumber(
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                </>
              )}
              {(props?.isAddUser ||
                props?.data?.emergency_contact_name_three) && (
                <>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="First Name"
                        value={thirdEmergencyContactName}
                        onChange={(e) =>
                          setThirdEmergencyContactName(e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Relationship</Form.Label>
                      <select
                        name="select"
                        class="form-control form-select form-select"
                        defaultValue={null}
                        value={thirdEmergencyContactRelation}
                        onChange={(e) =>
                          setThirdEmergencyContactRelation(e.target.value)
                        }
                      >
                        <option disabled selected value={null}>
                          {"Select Option"}
                        </option>
                        <option value={"Father"}>{"Father"}</option>
                        <option value={"Mother"}>{"Mother"}</option>
                        <option value={"Brother"}>{"Brother"}</option>
                        <option value={"Sister"}>{"Sister"}</option>
                        <option value={"Cousin"}>{"Cousin"}</option>
                        <option value={"Uncle"}>{"Uncle"}</option>
                        <option value={"Friend"}>{"Friend"}</option>
                      </select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>Primary Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={thirdEmergencyContactNumber}
                        onChange={(e) =>
                          setThirdEmergencyContactNumber(e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formGridUserName">
                      <Form.Label>
                        {"Alternate Mobile Number(Optional)"}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={thirdEmergencyContactAlternateNumber}
                        onChange={(e) =>
                          setThirdEmergencyContactAlternateNumber(
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                </>
              )} */}
              {/* <h5 className="txt-primary">System Details</h5>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>User Signed Up as Host?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={userSignedUpAsHost}
                    onChange={(e) => setUserSignedUpAsHost(e.target.value)}
                  >
                    <option disabled selected value={""}>
                      {"Select Option"}
                    </option>
                    <option value={1}>{"Yes"}</option>
                    <option value={0}>{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>User Signed Up as Volunteer?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={userSignedUpAsVolunteer}
                    onChange={(e) => setUserSignedUpAsVolunteer(e.target.value)}
                  >
                    <option disabled selected value={""}>
                      {"Select Option"}
                    </option>
                    <option value={1}>{"Yes"}</option>
                    <option value={0}>{"No"}</option>
                  </select>
                </Form.Group>
              </Col> */}
              {/* {!props?.isAddUser && (
                <Col md={3}>
                  <Form.Group
                    controlId="formGridUserName"
                    className="input-group-solid"
                  >
                    <Form.Label>Created On</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Date"
                      disabled
                      value={extractDateFromISO(props?.data?.create_on)}
                    />
                  </Form.Group>
                </Col>
              )}
              {!props?.isAddUser && (
                <Col md={3}>
                  <Form.Group
                    controlId="formGridUserName"
                    className="input-group-solid"
                  >
                    <Form.Label>Last Modified On</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Date"
                      disabled
                      value={extractDateFromISO(props?.data?.last_modified_on)}
                    />
                  </Form.Group>
                </Col>
              )}
              {!props?.isAddUser && (
                <Col md={3}>
                  <Form.Group
                    controlId="formGridUserName"
                    className="input-group-solid"
                  >
                    <Form.Label>Deactivated On</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Date"
                      disabled
                      value={extractDateFromISO(props?.data?.deactivated_on)}
                    />
                  </Form.Group>
                </Col>
              )} */}
              {/* {!props?.isAddUser && (
                <Row className="g-3">
                  <h5 className="txt-primary">User Activity Analytics</h5>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Last Logged On</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Last Logged On"
                        disabled
                        value={
                          props.data?.last_logged_on
                            ? extractDateFromISO(props.data.last_logged_on)
                            : '--'
                        }
                      />
                    </Form.Group>

                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Average Usage</Form.Label>
                      <Form.Control type="text" placeholder="--" disabled />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Last Known Location</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Latitude,Longitude"
                        disabled
                        value={`${userLogData?.latitude ?? "-"},${userLogData?.longitude ?? "-"
                          }`}
                      // onChange={(e) => setUserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Last Waypoint Visited</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Waypoint Id"
                        disabled
                        value={userLogData?.wpt_id ?? "--"}
                      // onChange={(e) => setUserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Journey Status</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="--"
                        disabled
                        value={
                          userLogData?.is_completed === 1
                            ? "Completed"
                            : userLogData?.created_at
                              ? exceedsBy7Days(userLogData?.created_at)
                                ? "Unknown"
                                : "Active"
                              : "Unknown"
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )} */}
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            form="AddUserForm"
            variant="primary"
            type="submit"
            onClick={handleSubmit}
          >
            {uploading ? "Uploading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddUser;
